/**
 * Route templating for telemetry.
 *
 * Lives in `lib/` rather than in `app.tsx` because `errorReporting` needs it
 * too, and `app.tsx` → `ErrorBoundary` → `errorReporting` would close an import
 * cycle. Keeping it here means every telemetry surface can reach the SAME
 * redaction rather than growing its own.
 */

/**
 * Segments whose *second* element is a secret, not an identifier.
 *
 * On this app the token IS the path — `/join/<invite>`, `/r/<shareToken>`,
 * `/reset-password/<token>` — so stripping the query string is not enough to
 * keep tokens out of telemetry. Anything not on this list collapses to
 * `/other`, which also stops scanner noise (`/wp-includes/...`) from minting a
 * row per probed URL.
 */
const KNOWN_ROUTES = new Set([
  'join', 'phase-invite', 'join-code', 'contribute', 'thread', 'r', 'recap',
  'spaces', 'subscription', 'support', 'terms', 'privacy', 'how-it-works',
  'reset-password', 'cancel-deletion',
]);

/**
 * Collapse identifier segments so events group by SCREEN, not by visitor.
 * A raw path would make every join link its own row and leak the token.
 */
export function routePattern(path: string): string {
  const segments = path.split('/').filter(Boolean);
  if (segments.length === 0) return '/';
  const head = segments[0];
  if (!KNOWN_ROUTES.has(head)) return '/other';
  return `/${head}${segments.length > 1 ? '/:param' : ''}`;
}
